import { ChangeTitle } from "Components/menu/funciones"
import MUIDataTable from "mui-datatables"
import { useEffect, useState } from "react"

import useHasPermission from "#hooks/useHasPermission"
import { Box, Stack } from "@mui/material"
import Skeleton from "@mui/material/Skeleton"
import DialogDetailBaja from "./DialogDetailBaja/DialogDetailBaja"
import { UseBajasV1 } from "./UseBajas"
import { ContextBajaProvider } from "./contexts/contexts"

export default function SolicitudesBajas() {
	ChangeTitle("bajas")
	const { hasPermissionV2 } = useHasPermission()
	const [reloadBajas, setReloadBajas] = useState(false)
	const reload = () => {
		setReloadBajas(!reloadBajas)
	}
	const is_rh = hasPermissionV2("RH")
	const { bajas, loading } = UseBajasV1({ reload: reloadBajas })
	const [open, setOpen] = useState(false)
	const [baja, setBaja] = useState({})
	const [selectIndex, setSelectIndex] = useState(null)
	const [dialogIndex, setDialogIndex] = useState(0)
	const columnNoShow = {
		options: {
			filter: false,
			sort: false,
			display: false,
		},
	}
	const columns = [
		{
			name: "id",
			label: "# ID",
			options: {
				filter: false,
				sort: false,
				display: true,
			},
		},
		{ name: "sucursal", label: "Sucursal" },
		{ name: "collaborator", ...columnNoShow },
		{ name: "request_collaborator", ...columnNoShow },
		{ name: "name_collaborator", label: "Colaborador" },
		{ name: "name_request_collaborator", label: "Solicitante" },
		{
			name: "type",
			label: "Tipo de baja",
			options: {
				filter: false,
				sort: false,
				display: is_rh,
			},
		},
		{ name: "termination_status", label: "Estatus" },
		{ name: "termination_date", label: "Fecha de baja" },
		{ name: "request_date", label: "Fecha de solicitud" },
		//   { name: "approval_date", label: "Fecha VoBo RH" },
	]
	const options = {
		textLabels: {
			body: {
				noMatch: "no hay solicitudes",
			},
		},
		filterType: "checkbox",
		search: true,
		filter: true,
		download: true,
		print: false,
		viewColumns: false,
		onRowClick: (rowData, rowMeta) => {
			setOpen(true)
			setSelectIndex(rowMeta.dataIndex)
		},

		selectableRows: "none",
	}
	//Esqueleto de tabla de solicitudes de bajas
	useEffect(() => {
		if (selectIndex !== null) {
			setBaja(bajas[selectIndex])
		}
	}, [bajas, selectIndex])

	if (loading) return <SkeletonTable />

	return (
		<ContextBajaProvider reload={reloadBajas} setReload={setReloadBajas}>
			<Box>
				<MUIDataTable data={bajas} columns={columns} options={options} />
				<DialogDetailBaja
					{...{ baja, open, setOpen, reload, dialogIndex, setDialogIndex }}
				/>
			</Box>
		</ContextBajaProvider>
	)
}

function SkeletonTable() {
	let componente = []
	let componente2 = []

	for (let index = 0; index < 8; index++) {
		componente.push(
			<Skeleton
				key={`SkeletonBaja${index}`}
				variant="rectangular"
				width={"80vw"}
				height={"5vh"}
			/>
		)
	}
	for (let index = 0; index < 8; index++) {
		componente2.push(
			<Stack key={`StackBaja${index}`} spacing={1} direction={"row"}>
				{componente}
			</Stack>
		)
	}

	return (
		<Box sx={{ width: "100%" }}>
			<Stack spacing={2}>
				<Skeleton variant="rectangular" width={"96vw"} height={"10vh"} />
				{componente2}
			</Stack>
		</Box>
	)
}
